import store from '@advisor/store';
import {PLATFORM_AREA, COMPONENT_ID, RIA_COMPONENT, NOTIFICATION_TYPE} from '@advisor/util/constants';

export default [
  {
    // Clients: [Clients, Households]
    path: '/advisor/clients',
    name: 'Clients',
    component: () => import('@advisor/components/clients/ClientAndHouseholds'),
    meta: {
      breadCrumbs: {
        to: '/advisor/client',
        text: '',
        title: 'Clients & Households',
        componentId: COMPONENT_ID.CLIENTS_HOUSEHOLD,
      },
      riaComponent: RIA_COMPONENT.CLIENTS,
      platformArea: PLATFORM_AREA.CLIENTS,
      visibilityComponentId: COMPONENT_ID.CLIENTS,
    },
  },
  {
    // Clients: [Clients, Households]
    path: '/advisor/households',
    name: 'Households',
    component: () => import('@advisor/components/clients/ClientAndHouseholds'),
    meta: {
      breadCrumbs: {
        to: '/advisor/client',
        text: '',
        title: 'Clients & Households',
        componentId: COMPONENT_ID.CLIENTS_HOUSEHOLD,
      },
      riaComponent: RIA_COMPONENT.CLIENTS,
      platformArea: PLATFORM_AREA.CLIENTS,
      visibilityComponentId: COMPONENT_ID.CLIENTS,
    },
  },
  {
    // Clients: Client Details
    path: '/advisor/client/:clientId/:sectionId?/',
    component: () => import('@advisor/components/clients/ClientDetails'),
    name: 'ClientDetails',
    meta: {
      breadCrumbs: {
        to: '/advisor/clients',
        text: 'Clients & Households',
        title: 'Client',
        componentId: 2,
      },

      platformArea: PLATFORM_AREA.CLIENTS,
      visibilityComponentId: COMPONENT_ID.CLIENTS,
      riaComponent: RIA_COMPONENT.CLIENTS,
    },
  },
  {
    // Clients: Goals Details
    path: '/advisor/goal/:clientId/:goalId/:sectionId?/',
    component: () => import('@advisor/components/clients/clientDetails/goal/GoalDetail'),
    name: 'GoalDetail',
    // eslint-disable-next-line consistent-return
    beforeEnter: async (to, from, next) => {
      try {
        const response = await store.dispatch('client/getClientSpecificInfo', {
          id: to.params.clientId,
        });

        // eslint-disable-next-line require-atomic-updates, no-param-reassign
        to.meta.childBreadCrumb.to = `/advisor/client/${to.params.clientId}`;
        // eslint-disable-next-line require-atomic-updates, no-param-reassign
        to.meta.childBreadCrumb.text = `${response.firstName} ${response.lastName}`;
      } catch (error) {
        const msg = {
          type: NOTIFICATION_TYPE.ERROR,
          text: 'Error: Client details could not be retrieved.',
          timeout: 5,
        };

        store.dispatch('notification/setMessage', msg);

        return Promise.reject(error);
      }
      next();
    },
    meta: {
      breadCrumbs: {
        to: '/advisor/clients',
        text: 'Clients & Households',
        title: 'Goal',
        componentId: COMPONENT_ID.GOALS,
      },
      childBreadCrumb: {
        to: '/advisor/client/',
        text: '',
      },
      platformArea: PLATFORM_AREA.CLIENTS,
      visibilityComponentId: COMPONENT_ID.CLIENTS,
      riaComponent: RIA_COMPONENT.CLIENTS,
    },
  },
  {
    // User: Account Details
    path: '/advisor/account/:clientId/:accountId/:sectionId?/',
    component: () => import('@advisor/components/clients/clientDetails/account/AccountDetails'),
    name: 'AccountDetails',
    // eslint-disable-next-line consistent-return
    beforeEnter: async (to, from, next) => {
      try {
        const response = await store.dispatch('client/getClientSpecificInfo', {
          id: to.params.clientId,
        });

        // eslint-disable-next-line require-atomic-updates, no-param-reassign
        to.meta.childBreadCrumb.to = `/advisor/client/${to.params.clientId}`;
        // eslint-disable-next-line require-atomic-updates, no-param-reassign
        to.meta.childBreadCrumb.text = `${response.firstName} ${response.lastName}`;
      } catch (error) {
        const msg = {
          type: NOTIFICATION_TYPE.ERROR,
          text: 'Error: Client details could not be retrieved.',
          timeout: 5,
        };

        store.dispatch('notification/setMessage', msg);

        return Promise.reject(error);
      }
      next();
    },
    meta: {
      breadCrumbs: {
        to: '/advisor/clients',
        text: 'Clients & Households',
        title: 'Account',
        componentId: COMPONENT_ID.ACCOUNT,
      },
      childBreadCrumb: {
        to: '/advisor/client/',
        text: '',
      },
      platformArea: PLATFORM_AREA.CLIENTS,
      visibilityComponentId: COMPONENT_ID.CLIENTS,
      riaComponent: RIA_COMPONENT.CLIENTS,
    },
  },
];
